<template>
    <div class="list-page-wrap">
        <transition name="fade" mode="out-in">
            <div>
                <div class="from_design">
                    <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline bg-color"
                        size="mini" @submit.native.prevent="onSubmit">
                        <el-form-item label="" prop="managed_number">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">规则ID</div>
                                </div>
                                <div class="append">
                                    <el-input v-model="formInline.managed_number" placeholder="精准查询"
                                        style="width: 120px" clearable @keyup.enter.native="onSubmit"></el-input>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="managed_name">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">规则名称</div>
                                </div>
                                <div class="append">
                                    <el-input v-model="formInline.managed_name" placeholder="请输入关键字查询" style="width: 140px"
                                        clearable @keyup.enter.native="onSubmit"></el-input>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="managed_status">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">状态</div>
                                </div>
                                <div class="append">
                                    <el-select v-model="formInline.managed_status" placeholder="请选择"
                                        style="width: 120px;" clearable>
                                        <el-option label="开启" value="1"></el-option>
                                        <el-option label="关闭" value="2"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="plat_id">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">媒体</div>
                                </div>
                                <div class="append">
                                    <SelectAll :options="allowedPlatList" v-model="formInline.plat_id"/>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="dimension">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">目标维度</div>
                                </div>
                                <div class="append">
                                    <SelectAll :options="dimensionList" v-model="formInline.dimension"/>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="user_ids">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">创建人</div>
                                </div>
                                <div class="append">
                                    <SelectAll :options="userList" v-model="formInline.user_ids"/>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="group_ids">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">创建人部门</div>
                                </div>
                                <div class="append">
                                    <cascader-all
                                    :options="groupList"
                                    :width="200"
                                    :lineHeight="28"
                                    v-model="formInline.group_ids"
                                    @change="(val)=>handleGroupId(val)"
                                    clearable
                                    ref="cascaderAall"
                                    />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" prop="range_time">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">创建时间</div>
                                </div>
                                <div class="append">
                                    <el-date-picker v-model="formInline.range_time" type="daterange" align="right"
                                        unlink-panels range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" :picker-options="basePickerOptions"
                                        value-format="yyyy-MM-dd" clearable style="width: 240px">
                                    </el-date-picker>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" prop="edit_time">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">修改时间</div>
                                </div>
                                <div class="append">
                                    <el-date-picker v-model="formInline.edit_time" type="daterange" align="right"
                                        unlink-panels range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" :picker-options="basePickerOptions"
                                        value-format="yyyy-MM-dd" clearable style="width: 240px">
                                    </el-date-picker>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="creator">

                            <div class="clever-form-item">
                                <div class="prefix">
                                    <el-select v-model="dimension_config_data_id" placeholder="请选择" @change="handleDimension"
                                        style="width: 60px;">
                                        <el-option :label="option.name" :value="option.id" v-for="option in filterList"
                                                   :key="option.id"></el-option>
                                    </el-select>
                                </div>
                                <div class="append">
                                    <SelectAll :options="dimensionConfigList" v-model="formInline.dimension_config_search" :virtual="true" :width="220"/>
                                </div>
                            </div>
                        </el-form-item>
                        <el-divider class="mt10 mb0" />
                        <el-form-item class="">
                            <el-button v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: '筛选(查询)' }" type="primary" @click="onSubmit" :loading="loading">查询</el-button>
                            <el-button v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: '筛选(清空筛选)' }" @click="resetForm('formInline', true)">清空筛选</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="bg-white pt10 pl10 pr10 pb10 mt10 borderRadius5">
                    <div class="mb10">
                        <el-button v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: '添加托管' }" type="primary" @click="createRule" size="small" icon="el-icon-plus" v-if="getCurAuth('add_intelligent_managed')">添加托管</el-button>
                    </div>
                    <jt-table :data="tableData" style="width: 100%" stripe
                        :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini" class="create_list"
                        v-loading="loading" tooltip-effect="dark">
                        <el-table-column label="规则名称" min-width="180" prop="managed_name" fixed="left">
                            <template v-slot="scope">
                                <MullineEllips :text="scope.row.managed_name" :lines="2" />
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" min-width="100" prop="managed_status">
                            <template v-slot="scope">
                                <el-switch :value="scope.row.managed_status" active-value="1" inactive-value="2" @change="fetchStatus(scope.row)" :disabled="!getCurAuth('intelligent_managed_status')">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="媒体" min-width="100" prop="plat_name">
                            <template v-slot="scope">
                                <span>{{ scope.row.plat_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="目标维度" min-width="100" prop="dimension">
                            <template v-slot="scope">
                                <span>{{ scope.row.dimension }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="维度筛选" min-width="180" prop="dimension_config">
                            <template v-slot="scope">
                                <span>{{ scope.row.dimension_config }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="触发操作" min-width="120" prop="trigger_action">
                            <template v-slot="scope">
                                <span>{{ scope.row.trigger_action }}</span>
                                <HoverEllipsisTips :text="scope.row.trigger_action_text || '-'" />
                            </template>
                        </el-table-column>
                        <el-table-column label="执行时间" min-width="180" prop="execute_time_frequency">
                            <template v-slot="scope">
                                <span>{{ scope.row.execute_time_frequency_text }}
                                    {{ scope.row.execute_time_frequency_data ? scope.row.execute_time_frequency_data : '' }}
                                    {{ scope.row.execute_time_start }} {{ scope.row.execute_time_end }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="检查频次" min-width="120" prop="check_frequency_time">
                            <template v-slot="scope">
<!--                                <span>{{scope.row.check_frequency_time}}</span>-->
                                <MullineEllips :text="scope.row.check_frequency_time" :lines="2" />
                            </template>
                        </el-table-column>
                        <el-table-column label="规则ID" min-width="120" prop="managed_number">
                            <template v-slot="scope">
                                <span>{{ scope.row.managed_number }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="运行次数" min-width="120" show-overflow-tooltip prop="run_record_num">
                            <template v-slot="scope">
                                <span @click="handleRunPush(scope.row, 'RunRecordPage', scope.row.run_record_num)" :style="{color: '#409EFF', cursor: 'pointer'}">{{ scope.row.run_record_num }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="触发次数" min-width="120" prop="trigger_record_num">
                            <template v-slot="scope">
                                <span @click="handleRunPush(scope.row, 'TriggerRecordPage', scope.row.trigger_record_num)" :style="{color: '#409EFF', cursor: 'pointer'}">{{ scope.row.trigger_record_num }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建人" min-width="100" prop="c_user_name">
                            <template v-slot="scope">
                                <span>{{ scope.row.user_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" min-width="90" prop="ctime">
                            <template v-slot="scope">
                                <span>{{ scope.row.ctime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="最新编辑人" min-width="120" prop="e_user_name">
                            <template v-slot="scope">
                                <span>{{ scope.row.e_user_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="最新编辑时间" min-width="120" prop="edit_time">
                            <template v-slot:default="scope">
                                <span>{{ scope.row.edit_time }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="180" fixed="right">
                            <template v-slot="scope">
                                <div>
                                    <el-button size="mini" type="text"
                                        v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: `列表(编辑)` }"
                                        @click="toConfigPage(scope.$index, scope.row,'edit')" v-if="getCurAuth('edit_intelligent_managed')">编辑</el-button>
                                    <el-button size="mini" type="text"
                                        v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: `列表(详情)` }"
                                        @click="toConfigPage(scope.$index, scope.row,'view')" v-if="getCurAuth('intelligent_managed_info')">详情</el-button>
                                    <el-button size="mini" type="text"
                                        v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: `列表(复制)` }"
                                        @click="toConfigPage(scope.$index, scope.row,'copy')" v-if="getCurAuth('intelligent_managed_copy')">复制</el-button>

                                    <el-popconfirm title="删除后运行记录与触发记录将不可查，确认要删除吗？" @confirm="fetchDel(scope.row)" v-if="getCurAuth('delete_intelligent_managed')">
                                        <el-button size="mini" type="text" slot="reference"
                                            v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: `列表(删除)` }"
                                            :style="{ marginLeft: '10px' }">删除</el-button>
                                    </el-popconfirm>
                                </div>

                            </template>
                        </el-table-column>
                    </jt-table>
                    <div class="tar pt20 pr20">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>


        </transition>
    </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list';
import OptionsItem from '../components/virtualListItem';
import SelectAll from '../components/selectAll.vue';
import CascaderAll from '../components/cascaderAll';
import MullineEllips from '@/components/MullineEllips';
import API from '@/api/intelligent/intelligentManaged/index.js';
import HoverEllipsisTips from "@/components/TextEllips/index.vue";
import {mapGetters} from "vuex";
export default {
    name: "RulePage",   // 智能投放/智能托管/托管规则
    components: {
        MullineEllips,
        CascaderAll,
        SelectAll,
        VirtualList,
        HoverEllipsisTips
    },
    props: {
        allowedPlatList: Array,
        pageFuncNames:Array,
        reload:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            itemComponent: OptionsItem,
            basePickerOptions: {
                firstDayOfWeek: 1,
                shortcuts: [
                    {
                        text: '最近7天',
                        onClick(picker) {
                            const date = new Date();
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                            let endDate = new Date(date.getTime());
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            // 上周：自然周，周一到周日
                            let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7);
                            let weekDay = date.getDay();
                            let startDate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * (weekDay === 0 ? 6 : weekDay - 1));
                            let endDate = new Date(startDate.getTime() + 1000 * 60 * 60 * 24 * 6);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-' + month + '-1';
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            let startDate = new Date(year + '-' + month + '-01');
                            let endDate = new Date(new Date(year + '-' + (month + 1) + '-01').getTime() - 1000 * 60 * 60 * 24);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = year + '-01-01';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-04-01';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-07-01';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-10-01';
                            }
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;

                            let startDate = '';
                            let endDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = (year - 1) + '-10-01';
                                endDate = (year - 1) + '-12-31';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-01-01';
                                endDate = year + '-03-31';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-04-01';
                                endDate = year + '-06-30';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-07-01';
                                endDate = year + '-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                ]
            },
            dimensionList: [
                {id: 1, name: '账户'},
                {id: 2, name: '产品'},
                {id: 3, name: '计划'},
                {id: 4, name: '创意'}
            ],
            filterList: [
                {
                    id: 1,
                    name: '集团'
                },
                {
                    id: 2,
                    name: '客户'
                },
                {
                    id: 3,
                    name: '账户'
                },
                {
                    id: 4,
                    name: '产品'
                },
                {
                    id: 5,
                    name: '计划'
                },
                {
                    id: 6,
                    name: '创意'
                }
            ],
            userList: [],
            groupList: [],
            dimensionConfigList: [],
            dimension_config_data_id: 1,
            formInline: {
                managed_number: "",        //规则ID
                managed_name: "",          //规则名称
                plat_id: [],            //渠道ID
                user_ids: [],           //创建人
                group_ids: [],          //创建部门
                range_time: [],           //创建时间区间
                managed_status: '',         //状态
                edit_time: [],              //修改时间区间
                dimension: [],        //目标维度：账户/产品/计划/创意
                dimension_config_search: []
            },
            tableData: [],
            loading: false,  // 表格loading
            currentPage: 1,
            pageSize: 30,
            total: 10,
            affixTopVal:'',     // 处理跳转详情页后affix消失
        }
    },
    watch: {
        'reload': {
            handler(n, o){
                if(n == 'create'){
                    this.handleDimension(this.dimension_config_data_id)
                    this.resetForm()
                    this.$emit('update:reload', '')
                }else if(n == 'edit') {
                    this.onSubmit()
                    this.$emit('update:reload', '')
                }
            },
            deep: true
        },
    },
    computed:{
        getFilterNumber(){
            return [3,4,5,6].includes(this.dimension_config_data_id)
        }
    },
    mounted() {
        this.fetchOptions('user', 'userList')
        this.fetchOptions('group', 'groupList')
        this.handleDimension(this.dimension_config_data_id)
        this.onSubmit()
    },
    methods: {
        createRule() {
            this.$emit('changePage', 'CreatePage', {},'add')
        },
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        onSubmit() {
            let res_range_time = this.formInline.range_time ? this.formInline.range_time.join('/') : ''; //时间的格式处理
            let res_edit_time = this.formInline.edit_time ? this.formInline.edit_time.join('/') : ''; //时间的格式处理
            let res_group_ids = this.formInline.group_ids.map(item=>{
                return item.join('-')
            })

            let post_obj = { ...this.formInline,
                group_ids: res_group_ids,
                range_time: res_range_time,
                edit_time: res_edit_time,
                pn:this.currentPage,
                rn:this.pageSize
            }

            if(this.formInline.dimension_config_search.length != 0) {
                post_obj['dimension_config'] = this.dimension_config_data_id
                if(this.formInline.dimension_config_search.includes('1')) {
                    post_obj['attribute'] = true
                }
            }
            this.fetchList(post_obj)
        },
        resetForm() {
            this.$refs['formInline'].resetFields();
            this.formInline.group_ids = []
            this.formInline.dimension_config_search = []
            this.$refs.cascaderAall.choiceEle = []
            this.onSubmit()
        },
        handleDimension(val) {
            this.formInline.dimension_config_search = []
            API.getIntelligentGetSearchLists({search_type: 'dimension_config', dimension_config_data_id: val }).then(res=>{
                this.dimensionConfigList = res.data.map((item, index)=>{
                    item['uid'] = index
                    item['type'] = this.dimension_config_data_id

                    let cur_platName = item.plat_name ? `(${item.plat_name})` : ''
                    let cur_packName = this.dimension_config_data_id == 4 ? `${item.subproject_content ? `${item.subproject_content}` : ''}` : ''
                    let cur_id = ''
                    if(this.dimension_config_data_id != 1 && this.dimension_config_data_id != 2) {
                        cur_id = `-${item.id}`
                    }
                    item['name'] = `${item.name}${cur_id}${cur_packName}${cur_platName}`

                    return item
                })

            },err=>{
                this.$message.error(err.info);
            })
        },
        handleGroupId(val) {
            this.formInline.group_ids = val
        },
        handleRunPush(row, path, text) {
            if(!row.managed_number) return
            if(text == '' || text == 0) {
                this.$message.error('记录为零，无法跳转');
                return;
            }
            let params = {}
            if(path == 'RunRecordPage') {
                params = {id:row.managed_number, ctime:row.ctime}
            }else if(path == 'TriggerRecordPage') {
                params = {managed_number:row.managed_number, ctime:row.ctime}
            }

            this.$emit('changePage', path, params)
        },
        // 获取下拉筛选
        fetchOptions(type, el) {
            API.getIntelligentGetSearchLists({search_type: type}).then(res=>{
                try {
                    if(type == 'group') {
                        this[el] = this.modifyIdsToValues(res.data)
                    }else{
                        this[el] = res.data
                    }
                } catch (err) {
                    console.error(err)
                }

            },err=>{
                this.$message.error(err.info);
            })
        },
        modifyIdsToValues(arr) {
            return arr.map(obj => {
                const newObj = { ...obj };
                if (newObj.children && newObj.children.length > 0) {
                    newObj.children = this.modifyIdsToValues(newObj.children);
                }
                if (newObj.hasOwnProperty('id')) {
                    newObj.value = newObj.id;
                    newObj.label = newObj.name
                    delete newObj.id;
                    delete newObj.name;
                }

                return newObj;
            });
        },
        // 列表查询
        fetchList(params) {
            this.loading = true
            API.getIntelligentGetLists(params).then(res=>{
                this.tableData= res.data.list
                this.total = res.data.totalCnt
                this.loading = false
                // this.$forceUpdate()
            }, err => {
                this.$message.error(err.info);
                this.loading = false
            })
        },
        // 状态变更
        fetchStatus(rows) {
            let change_status = rows.managed_status == '1' ? "2" : "1"
            API.postIntelligentChangeStatus({managed_status: change_status, managed_id: rows.managed_id}).then(res=>{
                if(res.code == 200) {
                    rows.managed_status = rows.managed_status == '1' ? "2" : "1"
                    this.$message.success('状态变更成功');
                }
            }, err => {
                this.$message.error(err.info);
            })
        },
        // 删除
        fetchDel(rows) {
            API.postIntelligentDelete({managed_id: rows.managed_id}).then(res=>{
                if(res.code == 200) {
                    let del_index = this.tableData.findIndex(item => item.managed_id == rows.managed_id)
                    console.log('del_index', del_index)
                    if(del_index !== -1) {
                        // this.tableData.splice(del_index, 1)
                        this.$message.success('删除成功');
                        this.onSubmit()
                    }
                }
            }, err => {
                this.$message.error(err.info);
            })
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.onSubmit()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.onSubmit()
        },
        toConfigPage(index,row,type){
            this.$emit("changePage", "CreatePage",row,type);
        },
    },
    deactivated() {
        const $vueAffix = document.querySelector('.vue-affix');
        let top = $vueAffix?.style.top;
        if(top&&$vueAffix.classList.contains('affix')){
            this.affixTopVal = top;
        }
    },
    activated() {
        const $vueAffix = document.querySelector('.vue-affix');
        if(this.affixTopVal&&$vueAffix){
            $vueAffix.classList.remove('affix-top');
            $vueAffix.classList.add('affix');
            $vueAffix.style.top = this.affixTopVal;
        }
    },
}
</script>

<style lang="scss" scoped>
// .list-page-wrap{
//     min-height:  calc(100vh - 110px);
// }
.from_design {
    background-color: #fff;
    border-radius: 5px;

    .el-input-group__prepend {
        background-color: #fff;
    }
}
</style>

<style lang="scss">
// .list-page-wrap{
//     min-height:  calc(100vh - 110px);
// }
.bg-white {
    background-color: #fff;
}

.borderRadius5 {
    border-radius: 5px;
}

.from_design {
    padding: 0 10px 10px 10px;

    .mb0 {
        margin-bottom: 0;
    }


    .el-input-group__prepend {
        background-color: #fff;
        padding-left: 6px;
        padding-right: 6px;
        position: relative;
        color: #5a5a5a;

        &:after {
            position: absolute;
            content: "";
            width: 1px;
            height: 14px;
            background-color: #5a5a5a;
            display: block;
            z-index: 9;
            right: -1px;
            top: 6px;
        }
    }

    // .el-input--suffix .el-input__inner{
    //     padding-left: 8px;
    // }
    .el-input-group--prepend .el-input__inner {
        border-left: none;
    }

    .el-input-group__prepend .el-select {
        margin-left: 0;
        margin-right: 0;
    }

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
        margin-bottom: 0;
        margin-top: 10px;
    }

    .clever-form-item {
        -webkit-appearance: none;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        outline: 0;
        padding: 0 0 0 15px;
        background-color: #fff;
        display: flex;
        align-items: center;

        .prefix {
            position: relative;
            font-size: 12px;

            .text {
                padding-right: 10px;
                color: #333;
            }

            &:after {
                position: absolute;
                content: "";
                width: 1px;
                height: 14px;
                background-color: #5a5a5a;
                display: block;
                z-index: 9;
                right: 0;
                top: 7px;
                transform: scale(0.8);
            }

            .el-input--suffix .el-input__inner {
                padding-left: 0;

                &::placeholder {
                    color: #333;
                }
            }
        }

        .el-input__inner {
            border: none;
            display: flex;
        }

    }
}
</style>
